module.exports = {
	"id": "NP",
	"name": "Nepal",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.006746,
			"5": 0.016865,
			"6": 0.006746,
			"7": 0.010119,
			"8": 0.006746,
			"9": 0.006746,
			"10": 0.010119,
			"11": 0.037103,
			"12": 0.047222,
			"13": 0.006746,
			"14": 0.006746,
			"15": 0.013492,
			"16": 0.023611,
			"17": 0.043849,
			"18": 0.010119,
			"19": 0.064087,
			"20": 0.026984,
			"21": 0.016865,
			"22": 0.03373,
			"23": 0.013492,
			"24": 0.030357,
			"25": 0.030357,
			"26": 0.030357,
			"27": 0.020238,
			"28": 0.043849,
			"29": 0.030357,
			"30": 0.070833,
			"31": 0.158531,
			"32": 0.293451,
			"33": 0.13492,
			"34": 0.016865,
			"35": 0.010119,
			"36": 0.016865,
			"37": 0.003373,
			"38": 0.016865,
			"39": 0.020238,
			"40": 0.013492,
			"41": 0.013492,
			"42": 0.016865,
			"43": 0.192261,
			"44": 0.030357,
			"45": 0.030357,
			"46": 0.030357,
			"47": 0.06746,
			"48": 0.043849,
			"49": 0.984916,
			"50": 0.064087,
			"51": 0.43849,
			"52": 0.310316,
			"53": 14.881676,
			"54": 3.572007,
			"55": 0.23611,
			"56": 0.074206,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.06746,
			"4": 0.030357,
			"5": 0.026984,
			"6": 0.023611,
			"7": null,
			"8": 0.003373,
			"9": 0.010119,
			"10": 0.006746,
			"11": 0.013492,
			"12": 0.026984,
			"13": 0.006746,
			"14": 0.016865,
			"15": 0.010119,
			"16": 0.010119,
			"17": 0.010119,
			"18": null,
			"19": 0.006746,
			"20": 0.006746,
			"21": 0.013492,
			"22": 0.010119,
			"23": 0.006746,
			"24": 0.006746,
			"25": 0.010119,
			"26": 0.003373,
			"27": 0.006746,
			"28": 0.020238,
			"29": 0.030357,
			"30": 0.020238,
			"31": 0.040476,
			"32": 0.016865,
			"33": 0.026984,
			"34": 0.023611,
			"35": 0.03373,
			"36": 0.026984,
			"37": 0.020238,
			"38": 0.037103,
			"39": 0.037103,
			"40": 0.023611,
			"41": 0.026984,
			"42": 0.030357,
			"43": 0.195634,
			"44": 0.151785,
			"45": 0.06746,
			"46": 0.057341,
			"47": 0.489085,
			"48": 0.357538,
			"49": 3.77776,
			"50": 0.762298,
			"51": 0.006746,
			"52": null,
			"3.5": null,
			"3.6": 0.010119
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.006746,
			"30": 0.003373,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.006746,
			"35": 0.006746,
			"36": 0.020238,
			"37": 0.060714,
			"38": 0.020238,
			"39": 0.016865,
			"40": 0.462101,
			"41": 0.053968,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.006746,
			"12.1": 0.013492
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": null,
			"7": 0.010119,
			"8": 0.030357,
			"9": 0.037103,
			"10": 0.195634,
			"3.1": null,
			"3.2": null,
			"5.1": 0.03373,
			"6.1": 0.010119,
			"7.1": 0.003373,
			"9.1": 0.118055
		},
		"ios_saf": {
			"8": 0,
			"10": 2.78607136137,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0750813993547,
			"8.1-8.4": 0.138709703893,
			"9.0-9.2": 0.0661734367194,
			"9.3": 1.00956909867
		},
		"android": {
			"3": 0,
			"4": 0.0918190542636,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0114773817829,
			"4.1": 0.331204445736,
			"4.2-4.3": 0.828011114341,
			"4.4": 1.89868687209,
			"4.4.3-4.4.4": 1.91508313178
		},
		"ie": {
			"6": 0.00694248543689,
			"7": 0.0242986990291,
			"8": 0.159677165049,
			"9": 0.0451261553398,
			"10": 0.0833098252427,
			"11": 0.395721669903,
			"5.5": null
		},
		"op_mob": {
			"0": 1.45376614634,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0403823929538
		},
		"edge": {
			"12": 0.141666,
			"13": 0.138293,
			"14": 0.131547
		},
		"ie_mob": {
			"10": 0.0797106760563,
			"11": 0.324536323944
		},
		"bb": {
			"7": 0.00828375,
			"10": null
		},
		"samsung": {
			"0": 2.173656
		},
		"and_uc": {
			"0": 8.290377
		},
		"op_mini": {
			"0": 19.5863384607
		},
		"and_chr": {
			"0": 26.245288
		},
		"and_ff": {
			"0": 0.013254
		}
	},
	"total": 98.57110275
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/NP.json
 ** module id = 612
 ** module chunks = 0
 **/